//import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {MessageService} from './../base/message.service';

import {Service} from './../base/service';
import {Loggers} from '../../../util/app-util';
import {cosechaClickEntity} from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class CosechaClicService extends Service<cosechaClickEntity>{

  httpClient: HttpClient;
  constructor(
    http: HttpClient,
    messageService: MessageService,
    protected override logger: Loggers,
    cookiesService: CookieService
  ) { 
    super('concentracion','',http, messageService, logger, cookiesService);
    this.httpClient = http;
  }

  protected getParams(entity: cosechaClickEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId.toString())}
    if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo.toString())}
    if (null != entity.PeriodoCosecha){params = params.set('PeriodoCosecha', entity.PeriodoCosecha.toString())}
    if (null != entity.PAR){params = params.set('PAR', entity.PAR.toString())}
    if (null != entity.BnPAR_Inclusive){params = params.set('BnPAR_Inclusive', entity.BnPAR_Inclusive.toString())}
    // if (null != entity.BnConIntereses){params = params.set('BnConIntereses', entity.BnConIntereses.toString())}
    return params;
  }

}
